import AdminLoginPage from "../pages/admin-login.svelte";
import AdminLoginOtpPage from "../pages/admin-login-otp.svelte";
import AdminHomePage from "../pages/admin-home.svelte";
import DealerTerminalPage from "../pages/dealer-terminal.svelte";
import UserTradingControlsPage from "../pages/user-trading-controls.svelte";
import StrategyManagerPage from "../pages/strategy-manager.svelte";
import GatewaySettingsPage from "../pages/gateway-settings.svelte";
import MasterDataManagerPage from "../pages/master-data-manager.svelte";
import MarketCalendarPage from "../pages/market-calendar.svelte";
import DealerBulkOrdersPage from "../pages/dealer-bulk-orders.svelte";
import MutualFundPortfolioPage from "../pages/mutual-fund-portfolio.svelte";
import ReferralsPage from "../pages/referrals.svelte";
import VerifyPennyDropPage from "../pages/verify-penny-drop.svelte";
import WithdrawRequestsPage from "../pages/withdraw-requests.svelte";
import AllReportsOfUserPage from "../pages/all-reports-of-user.svelte";
import ApproveAccountPage from "../pages/approve-account.svelte";
import RequestedCallbacksPage from "../pages/requested-callbacks.svelte";
import CashfreeTransactionsPage from "../pages/cashfree-transactions.svelte";
import AllUsersHomeDataPage from "../pages/all-users-home-data.svelte";
import EnachDebitRejectSpoBankPage from "../pages/enach-debit-reject-spo-bank.svelte";
import EnachDebitSkippedPage from "../pages/enach-debit-skipped.svelte";
import EnachDebitAllPage from "../pages/enach-debit-all.svelte";
import EnachDebitAcceptedSpoBankPage from "../pages/enach-debit-accepted-spo-bank.svelte";
import EnachDebitFailPage from "../pages/enach-debit-fail.svelte";
import EnachMandatePartialPage from "../pages/enach-mandate-partial.svelte";
import EnachDebitSuccessPage from "../pages/enach-debit-succ.svelte";
import EnachMandateRegSuccPage from "../pages/enach-mandate-reg-succ.svelte";
import EnachMandateAuthSuccPage from "../pages/enach-mandate-auth-succ.svelte";
import AllEnachPage from "../pages/all-enach.svelte";
import UserInfoPage from "../pages/user-info.svelte";
import UsersPage from "../pages/users.svelte";
import UserFullDetailsPage from "../pages/user-full-details.svelte";
import ApprovedUsersPage from "../pages/approved-users.svelte";
import ApprovedUsersFullDetailsPage from "../pages/approved-users-full-details.svelte";
import PendingUsersPage from "../pages/pending-users.svelte";
import PendingUsersFullDetailsPage from "../pages/pending-users-full-details.svelte";
import IncompleteUsersPage from "../pages/incomplete-users.svelte";
import IncompleteUsersFullDetailsPage from "../pages/incomplete-users-full-details.svelte";
import AdminUsersListPage from "../pages/admin-users-list.svelte";
import BseConformancePage from "../pages/bse-conformance.svelte";
import SystemDocsPage from "../pages/system-docs.svelte";
import F1f2MigrationGuidePage from "../pages/f1f2-migration-guide.svelte";
import DynamicRoutePage from "../pages/dynamic-route.svelte";
import NotFoundPage from "../pages/404.svelte";

import { checkAdminAuth } from "./auth";

/**
 * Direct Svelte Component Route Map for Framework7
 */
const routes = [
  {
    path: "/",
    component: AdminLoginPage,
  },
  {
    path: "/admin-login-otp/",
    component: AdminLoginOtpPage,
  },
  {
    path: "/admin-home/",
    component: AdminHomePage,
  },
  {
    path: "/system-docs/",
    component: SystemDocsPage,
  },
  {
    path: "/system-docs",
    component: SystemDocsPage,
  },
  {
    path: "/f1f2-migration-guide/",
    component: F1f2MigrationGuidePage,
  },
  {
    path: "/f1f2-migration-guide",
    component: F1f2MigrationGuidePage,
  },
  {
    path: "/f1f2-migration/",
    component: F1f2MigrationGuidePage,
  },
  {
    path: "/f1f2-migration",
    component: F1f2MigrationGuidePage,
  },
  {
    path: "/dealer-terminal/",
    component: DealerTerminalPage,
  },
  {
    path: "/user-trading-controls/",
    component: UserTradingControlsPage,
  },
  {
    path: "/strategy-manager/",
    component: StrategyManagerPage,
  },
  {
    path: "/gateway-settings/",
    component: GatewaySettingsPage,
  },
  {
    path: "/bse-conformance/",
    component: BseConformancePage,
  },
  {
    path: "/master-data-manager/",
    component: MasterDataManagerPage,
  },
  {
    path: "/master-data/",
    component: MasterDataManagerPage,
  },
  {
    path: "/market-calendar/",
    component: MarketCalendarPage,
  },
  {
    path: "/dealer-bulk-orders/",
    component: DealerBulkOrdersPage,
  },
  {
    path: "/mutual-fund-portfolio/",
    component: MutualFundPortfolioPage,
  },
  {
    path: "/referrals/",
    component: ReferralsPage,
  },
  {
    path: "/verify-penny-drop/",
    component: VerifyPennyDropPage,
  },
  {
    path: "/withdraw-requests/",
    component: WithdrawRequestsPage,
  },
  {
    path: "/all-reports-of-user/",
    component: AllReportsOfUserPage,
  },
  {
    path: "/approve-account/",
    component: ApproveAccountPage,
  },
  {
    path: "/requested-callbacks/",
    component: RequestedCallbacksPage,
  },
  {
    path: "/cashfree-transactions/",
    component: CashfreeTransactionsPage,
  },
  {
    path: "/all-users-home-data/",
    component: AllUsersHomeDataPage,
  },
  {
    path: "/enach-debit-reject-spo-bank/",
    component: EnachDebitRejectSpoBankPage,
  },
  {
    path: "/enach-debit-skipped/",
    component: EnachDebitSkippedPage,
  },
  {
    path: "/enach-debit-all/",
    component: EnachDebitAllPage,
  },
  {
    path: "/enach-debit-accepted-spo-bank/",
    component: EnachDebitAcceptedSpoBankPage,
  },
  {
    path: "/enach-debit-fail/",
    component: EnachDebitFailPage,
  },
  {
    path: "/enach-mandate-partial/",
    component: EnachMandatePartialPage,
  },
  {
    path: "/enach-debit-success/",
    component: EnachDebitSuccessPage,
  },
  {
    path: "/enach-mandate-reg-succ/",
    component: EnachMandateRegSuccPage,
  },
  {
    path: "/enach-mandate-auth-succ/",
    component: EnachMandateAuthSuccPage,
  },
  {
    path: "/all-enach/",
    component: AllEnachPage,
  },
  {
    path: "/user-info/",
    component: UserInfoPage,
  },
  {
    path: "/users/",
    component: UsersPage,
  },
  {
    path: "/user-full-details/",
    component: UserFullDetailsPage,
  },
  {
    path: "/approved-users/",
    component: ApprovedUsersPage,
  },
  {
    path: "/approved-users-full-details/",
    component: ApprovedUsersFullDetailsPage,
  },
  {
    path: "/pending-users/",
    component: PendingUsersPage,
  },
  {
    path: "/pending-users-full-details/",
    component: PendingUsersFullDetailsPage,
  },
  {
    path: "/incomplete-users/",
    component: IncompleteUsersPage,
  },
  {
    path: "/incomplete-users-full-details/",
    component: IncompleteUsersFullDetailsPage,
  },
  {
    path: "/admin-users-list/",
    component: AdminUsersListPage,
  },
  {
    path: "/dynamic-route/blog/:blogId/post/:postId/",
    component: DynamicRoutePage,
  },
  {
    path: "(.*)",
    component: NotFoundPage,
  },
];

const publicPaths = ["/", "/admin-login-otp/"];

const routesWithAuth = routes.map((route) => {
  if (route.path && !publicPaths.includes(route.path) && route.path !== "(.*)") {
    return {
      ...route,
      beforeEnter: checkAdminAuth,
    };
  }
  return route;
});

export default routesWithAuth;
